export interface CompanyHierarchy {
  id: number;
  company_name: string;
  hierarchy_type: string;
  direct_children?: CompanyHierarchy[];
  ultimate_parent_company_name: string;
  ultimate_parent_id: number;
  immediate_parent_company_id: number;
  immediate_parent_company_name: string;
  // The total_children does not need to be implemented this sprint,
  // it might help to render the load more button for the next sprint
  total_children?: number;
}

export enum HierarchyType {
  global = 'GLOBAL',
  operatingClient = 'OPERATING CLIENT',
  alias = 'ALIAS',
}
